import { render, staticRenderFns } from "./shop_home.vue?vue&type=template&id=2ea865cc&scoped=true"
import script from "./shop_home.vue?vue&type=script&lang=js"
export * from "./shop_home.vue?vue&type=script&lang=js"
import style0 from "./shop_home.vue?vue&type=style&index=0&id=2ea865cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea865cc",
  null
  
)

export default component.exports